import { getModelTypeIdAndEntityId } from '../config';
import service from './baseService';

export const getTourSpecialRequirementTypesService = () => {
    return service.get(`/tour-special-requirement-types`, { params: getModelTypeIdAndEntityId() });
};
